// NOTE - keep this around 20 entries
export const DEFAULT_SEO_KEYWORDS: string = [
    "Real World Assets",
    "RWA",
    "RWAs",
    "Tokenization",
    "Tokenized Assets",
    "Tokenized Real World Assets",
    "Tokenized Securities",
    "Tokenized Bonds",
    "Asset Tokenization",
    "Stablecoins",
    "Treasury Bonds",
    "Digital Securities",
    "Digital Bonds",
    "Digital Assets",
    "Market Data",
    "Financial Data",
    "Dashboard",
    "DeFi",
    "Decentralized Finance",
].join(", ");

export const AUTHOR_SEO = {
    "@type": "Organization",
    name: "RWA.xyz",
    url: "https://rwa.xyz",
};
